
/**
 * Custom component for WV Steak House default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-09-20 (1.0.0) (jhoward)
 *    - Copy from <WvSteakHouseDefaultSection> component to <oceano-default-section> component.
 *    - <oceano-default-section> assigns a random "fleur" to each section.
 *
 *  2023-10-25 (1.0.1) (jhoward)
 *    - Fix scoping on some global CSS in <oceano-default-section>.
 *
 *  2024-08-19 (1.0.2) (jhoward)
 *    - Add "rules" and "includes" copy section styling to <oceano-default-section>.
 *
 *  2025-02-10 (1.1.0) (jhoward)
 *    - Add <menu-schedules> to the <Oceano_defaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <Oceano_defaultSection>.
 *    - Add textual and visual menu CSS tweaks to <Oceano_defaultSection>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "OceanoDefaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: 'oceano-default-item',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
  computed: {
    containerClasses(): { [key: string]: boolean } {
      const output: { [key: string]: boolean }= {
        'menu--section-burgers': this.section.ms_title.toLowerCase().indexOf('burgers') > -1,
      };

      //random fleur for each section
      output['menu--section-title_fleur_' + Math.ceil(Math.random() * 5)] = true;

      return output;
    },
  },
})
